require('./expensesByCategoryHistogram.scss');

//@vendors
const React = require('react');
const PropTypes = require('prop-types');
const { formatText } = require('core/i18n').i18n;
const classNames = require('classnames');

//@components
const PfmBarChart = require('components/charts/pfmBarChart/pfmBarChart');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKSwitcherOptions } = require('commonsComponents/OKSwitcherOptions');
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { FormattedText } = require('core/i18n').i18n;
const { OKButton } = require('components/commons/OKButton/OKButton');
const FeatureTogglingRender = require('components/conditionalRender/featureTogglingRender');

// @constants
const { CATEGORY_KEYS: { INCOME_CATEGORY }, getCategoryIcon } = require('constants/categories');

// @constants
const { BAR_CHART_CREDIT, BAR_CHART_ACCOUNT_DEBIT, LINE_CHART_COLOR, BAR_CHART_ACCOUNT_DEBIT_OTHER_BANKS, BAR_CHART_CREDIT_OTHER_BANKS } = require('constants/charts');
const { ENABLED_CREDIT_CARD_FILTER } = require('constants/flagBasedFeatures');

// @images
const openTutorialImg = require('assets/images/icon-tutorial.svg');

class ExpensesByCategoryHistogram extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            filterType: '',
            chartData: [],
            periodTime: 'M',
            loading: false,
            categories: [],
            categorySelected: '',
            currency: '',
            creditSelected: true,
            debitSelected: true,
            lineChart: [],
            compareCharts: false,
            type: 'both'
        }

        this.changePeriodHistogram = this.changePeriodHistogram.bind(this);
        this.handleCompareCharts = this.handleCompareCharts.bind(this);
        this.handleDebit = this.handleDebit.bind(this);
        this.handleCredit = this.handleCredit.bind(this);
        this.handleCategories = this.handleCategories.bind(this);
        this.returnTypeContractSelected = this.returnTypeContractSelected.bind(this)
        this.getCategoriesSelectOptions = this.getCategoriesSelectOptions.bind(this);
        this.handleOpenFilter = this.handleOpenFilter.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            filterType: nextProps.filterType,
            chartData: nextProps.histogram,
            loading: nextProps.loading,
            currency: nextProps.currency,
            categorySelected: nextProps.selectedCategory,
            lineChart: nextProps.lineChart,
            creditSelected: nextProps.creditSelected,
            debitSelected: nextProps.debitSelected,
        });
        this.getCategoriesSelectOptions(nextProps.categories);
    }

    changePeriodHistogram(value) {
        const { type } = this.state;
        if (value !== this.state.periodTime) {
            const { onHandleChangePeriodHistogram } = this.props;
            this.setState({
                periodTime: value
            });
            onHandleChangePeriodHistogram(value, type);
        }
    }

    buildHistogramMonthTotal = () => {
        const {
            chartData,
            loading,
            periodTime,
            currency,
            lineChart,
            compareCharts,
            categorySelected
        } = this.state;
        const { blue } = this.props

        const interval = periodTime === 'D' ? 2 : 0 ;
        // Configuration to the barchart component
        const configChart = [
            {
                name: 'TotalDebit', //name to get the data
                color: !blue ? BAR_CHART_ACCOUNT_DEBIT : BAR_CHART_ACCOUNT_DEBIT_OTHER_BANKS, // color for bar
            },
            {
                name: 'TotalCredit',
                color: !blue ? BAR_CHART_CREDIT : BAR_CHART_CREDIT_OTHER_BANKS,
            }
        ];
        if (chartData.length > 0) {
            return(
                <PfmBarChart
                    chartData={chartData}
                    dataKeyBar={configChart}
                    loading={loading}
                    type="totalExpenses"
                    interval={interval}
                    periodTime={periodTime}
                    currency={currency}
                    lineChart={lineChart}
                    compareCharts={compareCharts}
                    hasCredit
                    hasDebit
                />
            )
        } else {
            if (loading) {
                return(
                    <section className="col-xs-12 col-md-12 expenses-histogram__empty">
                        <EmptyState
                            primaryText={categorySelected === INCOME_CATEGORY ? formatText('historic-emptyExpensesIncome') : formatText('historic-emptyExpenses')}
                            iconType="noitems-banking" />
                    </section>
                )
            }
        }
    }

    getCategoriesSelectOptions(categoriesListSorted) {
        let index = 0;
        let categories = [
            {
                index: index,
                value: '',
                label: formatText('historic-categoryDefaultValue')
            }
        ];
        categoriesListSorted.map(categoriesList => {
            index++;
            categories.push({
                index: index,
                value: categoriesList,
                label: formatText('categories-'+categoriesList),
                icon: getCategoryIcon(categoriesList)
            });
        });

        this.setState({
            categories: categories
        });
    }

    handleCategories(evt) {
        const { onHandleChangeCategoryHistogram } = this.props;
        const { type } = this.state;
        this.setState({ categorySelected: evt.value });
        onHandleChangeCategoryHistogram(evt.value, type);
    }

    handleBank = (evt) => {
        const { onHandleChangeBankHistogram } = this.props
        const { categorySelected } = this.state
        const category = categorySelected === 'all-categories' ? '' : categorySelected

        onHandleChangeBankHistogram(evt.value, category)
    }

    handleDebit() {
        const { creditSelected, debitSelected } = this.state;
        this.setState({
            debitSelected: !debitSelected
        });
        this.returnTypeContractSelected(!debitSelected, creditSelected);
    }

    handleCredit() {
        const { debitSelected, creditSelected } = this.state;
        this.setState({
            creditSelected: !creditSelected
        });
        this.returnTypeContractSelected(debitSelected, !creditSelected);
    }

    handleCompareCharts() {
        const { compareCharts } = this.state;
        this.setState({
            compareCharts: !compareCharts
        });
    }

    returnTypeContractSelected(debit, credit) {
        const { onHandleTypeContract } = this.props;
        let type = '';
        if (debit && credit) {
            type = 'both'
        } else if (!debit && credit) {
            type = 'credit'
        } else if (debit && !credit) {
            type = 'debit';
        }
        this.setState({
            type: type
        });
        onHandleTypeContract(type);
    }

    handleOpenFilter() {
        this.props.onOpenFilter(false);
    }

    render() {
        const { categories, categorySelected, loading, creditSelected, debitSelected, compareCharts } = this.state;
        const { filter, onHandleClearFilter, bankOptions, selectedBank, blue, flagBasedFeatures } = this.props;
        const tooltipTarget = (
            <img
                src={openTutorialImg}
                className="expenses-histogram__tooltip-element"
            />
        );
        const valuesSwitcher = [
            {
                option: formatText('historic-thisMonthTab'),
                value: 'D'
            },
            {
                option: formatText('historic-lastYearTab'),
                value: 'M'
            },
        ]

        const expensesHistogramChecksStyles = classNames('col-xs-12 col-md-12 expenses-histogram__checks', {
            '-no-credit-filter': flagBasedFeatures.get(ENABLED_CREDIT_CARD_FILTER),
        });

        return (
            <div className="expenses-histogram row">
                {loading === false &&
                    <div className="expenses-histogram__chart-loading">
                        <LoadingSection center={true} />
                    </div>
                }
                <div className="col-xs-8">
                    <h3 className="expenses-histogram__title">
                        <FormattedText value="historic-title" />
                        <OKTooltip
                            content="historic-titleTutorial"
                            offset={[15, 0]}
                            placement="right"
                            target={tooltipTarget}
                        />
                    </h3>
                </div>
                <div className="col-xs-4 expenses-histogram__filters-buttons">
                    {filter &&  <button className="expenses-by-category__button-clean" onClick={onHandleClearFilter}>
                        <FormattedText value="filters-clean" />
                    </button>}
                    <OKButton
                        id="btn_accountLastMovementsHeader_filterButton"
                        modifier="task"
                        onClick={this.handleOpenFilter}>
                        <i className="icon icon-filtrar expenses-by-category--filter-settings-icon" />
                    </OKButton>
                </div>
                <div className="col-xs-12 col-md-12 expenses-histogram__legend">
                    <div className="col-xs-4 col-md-4 expenses-histogram__legend__select-container">
                        <OKSelect
                            className="expenses-histogram__categories-select"
                            name="issuing-company-filter"
                            searchable={false}
                            options={categories}
                            onChange={this.handleCategories}
                            value={categorySelected}
                            placeholder={formatText('historic-categoryDefaultValue')}
                        />
                    </div>
                    {   bankOptions &&
                        <div className="col-xs-4 col-md-4 expenses-histogram__legend__select-container">
                            <OKSelect
                                className="expenses-histogram__bank-select"
                                name="company-filter"
                                searchable={false}
                                options={bankOptions.unshift({value: null, label: formatText('historic-bankDefaultValue')}).toJS()}
                                onChange={this.handleBank}
                                value={selectedBank}
                                placeholder={formatText('historic-bankDefaultValue')}
                            />
                        </div>
                    }
                    <OKSwitcherOptions
                        options={valuesSwitcher}
                        handleChangePeriod={this.changePeriodHistogram}
                        selected={1}
                    />
                </div>
                {this.buildHistogramMonthTotal()}
                <div className={expensesHistogramChecksStyles}>
                    <FeatureTogglingRender notAllowedProductKey={ENABLED_CREDIT_CARD_FILTER} >
                        <OKCheckbox
                            idName="debitLegend"
                            label={formatText('historic-debitLegend')}
                            onChange={this.handleDebit}
                            value={debitSelected}
                            hasLegend
                            colorLegend={!blue ? BAR_CHART_ACCOUNT_DEBIT : BAR_CHART_ACCOUNT_DEBIT_OTHER_BANKS}
                        />
                        <OKCheckbox
                            idName="creditLegend"
                            label={formatText('historic-creditLegend')}
                            onChange={this.handleCredit}
                            value={creditSelected}
                            hasLegend
                            colorLegend={!blue ? BAR_CHART_CREDIT : BAR_CHART_CREDIT_OTHER_BANKS}
                        />
                    </FeatureTogglingRender>
                    <OKCheckbox
                        idName="compareYears"
                        label={formatText('historic-lastYearExpenses')}
                        onChange={this.handleCompareCharts}
                        value={compareCharts}
                        hasLegend
                        colorLegend={LINE_CHART_COLOR}
                    />
                </div>
            </div>
        );
    }
}

ExpensesByCategoryHistogram.propTypes = {
    histogram: PropTypes.array,
    currency: PropTypes.string,
    categories: PropTypes.array,
    loading: PropTypes.bool,
    hasDebit: PropTypes.bool,
    hasCredit: PropTypes.bool,
    selectedCategory: PropTypes.string,
    selectedBank: PropTypes.string,
    onHandleChangeCategoryHistogram: PropTypes.func,
    onHandleChangePeriodHistogram: PropTypes.func,
    onHandleChangeBankHistogram: PropTypes.func,
    filterType: PropTypes.string,
    onOpenFilter: PropTypes.func,
    onHandleTypeContract: PropTypes.func,
    lineChart: PropTypes.array,
    debitSelected: PropTypes.bool,
    creditSelected: PropTypes.bool,
    filter: PropTypes.bool,
    onHandleClearFilter: PropTypes.func,
    bankOptions: PropTypes.object,
    blue: PropTypes.bool,
    flagBasedFeatures: PropTypes.object,
};

module.exports = { ExpensesByCategoryHistogram };
